import { Link } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function RetailCTABand() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-16 md:py-20 bg-gradient-to-r from-accent-600 via-accent-500 to-brand-700">
      <div
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.3'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>
      <div ref={ref} className={`container-page relative z-10 scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-paper-50 mb-4">
            Your Freezer Is Waiting
          </h2>
          <p className="text-accent-100/80 max-w-xl mx-auto mb-8 text-sm md:text-base">
            Ready to cook with confidence? Browse our full catalogue, set up a subscription, or talk to our team about bulk orders for your home or business.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/retail"
              className="px-8 py-3.5 bg-background-50 hover:bg-background-100 text-accent-700 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
            >
              Start Shopping
            </Link>
            <Link
              to="/contact"
              className="px-8 py-3.5 border-2 border-paper-300/30 hover:border-paper-50/60 text-paper-50 font-semibold text-sm rounded-lg transition-all hover:bg-paper-50/5 whitespace-nowrap cursor-pointer"
            >
              Talk to Our Team
            </Link>
          </div>

          {/* App download badges */}
          <div className="mt-8 flex items-center justify-center gap-4">
            <span className="text-xs text-accent-100/60">Coming soon on</span>
            <div className="flex items-center gap-3">
              <span className="inline-flex items-center gap-1.5 px-4 py-2 bg-paper-50/10 border border-paper-300/20 rounded-lg text-xs text-paper-50/60 cursor-not-allowed">
                <i className="ri-apple-line"></i>
                App Store
              </span>
              <span className="inline-flex items-center gap-1.5 px-4 py-2 bg-paper-50/10 border border-paper-300/20 rounded-lg text-xs text-paper-50/60 cursor-not-allowed">
                <i className="ri-google-play-line"></i>
                Google Play
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}